import { useField } from 'formik';
import { useTranslation } from 'react-i18next';
import { Box, Flex } from 'reflexbox';
import styled from 'styled-components';

import { Button, Paragraph } from '@treams/treams-ui';

import { TOTAL_NORM, distributeEvenly, totalNorm } from './norms';

const Total = styled(Box)<{ balanced: boolean }>`
	font-weight: bold;
	white-space: nowrap;
	color: ${(props) => (props.balanced ? props.theme.colors.green : props.theme.colors.red)};
`;

type NormCell = { norm?: number };

export default function TalentReviewNormDistribution() {
	const { t } = useTranslation();

	const [{ value: cells }, , { setValue: setCells }] = useField<NormCell[][]>('cells');

	const total = totalNorm(cells);
	const balanced = total === TOTAL_NORM;

	return (
		<Flex alignItems="center" justifyContent="flex-end" mt={3} mb={2}>
			<Paragraph color="slateBlue">{t('settings.talentReviews.edit.norm.title')}</Paragraph>
			<Box mx={3}>
				<Button
					type="secondary"
					small
					disableSuccess
					title={t('settings.talentReviews.edit.norm.distribute')}
					onClick={() => setCells(distributeEvenly(cells))}
				/>
			</Box>
			<Total balanced={balanced}>
				{t(
					balanced
						? 'settings.talentReviews.edit.norm.balanced'
						: 'settings.talentReviews.edit.norm.unbalanced',
					{ total },
				)}
			</Total>
		</Flex>
	);
}
